/**
 * parser for json, csv, ...
 */

export class DataParser{
    constructor(dataParserOptions= { parserType : 'json'}){
        var _parser;

        Object.defineProperty(this,'parser',{
            set : function(p){ _parser = p },
            get : function(){ return _parser }
        });

        this.initDataParser(dataParserOptions);
    }
    // ==========
    // private 
    // ----------

    setParser(p){ this.parser = p }
    getParser(){ return this.parser }

    parserJson(data){ return JSON.parse(data); }

    initDataParser(dataParserOptions){
        if (dataParserOptions){
            switch(dataParserOptions.parserType){
                case "json":
                    this.setParser(this.parserJson) 
                break; 
            }
        } 
    }

    // ==========
    // public 
    // ----------
    parse(data){
        var parser = this.getParser();
        return parser(data);
    }


}

export class DataParserOptions{
    constructor(){
        this.parserType = 'json';
    }
}

/*
var string = '[{"id":"TAN","name":"Tanlib","url":"https://tanlib.com/","timezone":"Europe/Paris","lang":"fr","phone":"05 49 09 09 00"},{"id":"TAN_RESA","name":"Tanlib","url":"https://tanlib.com/","timezone":"Europe/Paris","lang":"fr","phone":"0800 00 78 79"}]';
var dataParser = new DataParser();
var print = (data)=>{ console.log(data)}
var d = dataParser.parse(string)
console.log('parsed',d)
*/

